(function () {
  const MOBILE_BREAKPOINT = 990;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(section) {
    let swiperInstance;

    const rawDelay = parseInt(section.dataset.autoplay, 10);
    const autoplayDelay = !isNaN(rawDelay) && rawDelay > 0 && !prefersReducedMotion ? rawDelay : 0;
    const paginationEl = section.querySelector('.banner-grid__pagination');
    const playBtn = section.querySelector('.banner-grid__play-btn');

    const initSlider = () => {
      swiperInstance = new Swiper(section, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: autoplayDelay > 0,
        autoplay: autoplayDelay > 0
          ? { delay: autoplayDelay, disableOnInteraction: false }
          : false,
        pagination: paginationEl
          ? { el: paginationEl, clickable: true }
          : false,
      });

      if (playBtn && autoplayDelay > 0) {
        playBtn.classList.remove('is-paused');
        playBtn.setAttribute('aria-label', playBtn.dataset.labelPause);
      }
    };

    const destroySlider = () => {
      if (!swiperInstance) return;
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    };

    if (playBtn && autoplayDelay > 0) {
      playBtn.addEventListener('click', () => {
        if (!swiperInstance) return;
        if (swiperInstance.autoplay.running) {
          swiperInstance.autoplay.stop();
          playBtn.classList.add('is-paused');
          playBtn.setAttribute('aria-label', playBtn.dataset.labelPlay);
        } else {
          swiperInstance.autoplay.start();
          playBtn.classList.remove('is-paused');
          playBtn.setAttribute('aria-label', playBtn.dataset.labelPause);
        }
      });
    }

    const resizeObserver = new ResizeObserver(([entry]) => {
      const width = entry.contentRect.width;
      if (width === 0) return;
      if (width < MOBILE_BREAKPOINT) {
        if (!swiperInstance) initSlider();
      } else {
        destroySlider();
      }
    });

    resizeObserver.observe(section);

    return () => {
      destroySlider();
      resizeObserver.disconnect();
    };
  }

  const teardowns = new Map();

  document.querySelectorAll('.banner-grid--slider').forEach((section) => {
    teardowns.set(section, initSection(section));
  });

  document.addEventListener('shopify:section:load', ({ target }) => {
    const section = target.querySelector('.banner-grid--slider');
    if (!section) return;
    teardowns.set(section, initSection(section));
  });

  document.addEventListener('shopify:section:unload', ({ target }) => {
    const section = target.querySelector('.banner-grid--slider');
    if (!section || !teardowns.has(section)) return;
    teardowns.get(section)();
    teardowns.delete(section);
  });
})();
